<template>
  <div class="md-layout">
    <div class="md-layout-item" :style="{paddingLeft:isMobile.isMobile?'15px':'',paddingRight:isMobile.isMobile?'15px':''}">
      
      <md-toolbar color="success"  class="MobileToolbar" :style="{padding:isMobile.isMobile?'0px 20px':'0px', minHeight:isMobile.isMobile?'44px':'64px',height:isMobile.isMobile?'44px':'64px',lineHeight:isMobile.isMobile?'44px':'64px',margin:isMobile.isMobile?'10px 0':'0px'}">
        <span :style="{width: '80px', float: 'left', color: '#fff',lineHeight:isMobile.isMobile?'44px':'64px', margin:isMobile.isMobile?'0px 0px':'0px'  }">模型开发</span>
           <v-menu
           v-if="!isMobile.isMobile"
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.priority.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in priorityList"
                      :key="index"
                      @click="priorityType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
           </v-menu>
           <md-button
          v-if="isMobile.isMobile"
          class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
          :class="{ toggled: $sidebar.showSidebar }"
          style="float: right; color: #fff !important; margin-right: -6px"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <!-- <v-tabs
            background-color="#4caf50"
            dark
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          > -->

      
            <!-- <v-tab>
              <span style="width: 80px; float: left; color: #fff; margin: 20px">模型开发</span>
              </v-tab>
            <v-tab> -->
              <!-- ************************************************** -->
              <!-- <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.priority.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in priorityList"
                      :key="index"
                      @click="priorityType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu> -->
              <!-- ************************************************** -->
            <!-- </v-tab> -->
            <!-- <v-tab> -->
              <!-- ************************************************** -->
              <!-- <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.status.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in statusList"
                      :key="index"
                      @click="statusType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu> -->
              <!-- ************************************************** -->
            <!-- </v-tab> -->
            <!-- <v-tab>
              <div style="display: inline-block" @mouseenter="mouseenter" @mousedown="mouseDown">
                <el-cascader
                  size="small"
                  placeholder="全部"
                  @change="onchange"
                  v-model="optionsValue"
                  :props="cascaderProps"
                  id="coursefilterWrap"
                  ref="coursefilterWrap"
                  :show-all-levels="true"
                >
                  <template slot-scope="{ node, data }">
                    <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
                  </template>
                </el-cascader>
              </div>
            </v-tab> -->
          <!-- </v-tabs> -->
      </md-toolbar>

      <v-card>
        <!-- 搜索栏  -->
        <v-toolbar color="success" class="pcToolbar">
          <span style="width: 80px; float: left; color: #fff; margin: 20px">模型开发</span>
          <v-spacer></v-spacer>
          <div class="d-sm-flex justify-between">
            <div class="d-flex ms-auto">
              <!-- 项目分类 -->

              <!-- ************************************************** -->
              <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: 15px"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.priority.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                         <!-- <md-tooltip md-direction="top">优先级</md-tooltip> -->
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in priorityList"
                      :key="index"
                      @click="priorityType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <!-- ************************************************** -->
              <!-- ************************************************** -->
              <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: 15px"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.status.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                       <!-- <md-tooltip md-direction="top">制作状态</md-tooltip> -->
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in statusList"
                      :key="index"
                      @click="statusType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <!-- ************************************************** -->


                  <div style="display: inline-block" @mouseenter="mouseenter" @mousedown="mouseDown">
          <el-cascader
              size="small"
              placeholder="全部"
              @change="onchange"
              v-model="optionsValue"
              :props="cascaderProps"
              id="coursefilterWrap"
              ref="coursefilterWrap"
              :show-all-levels='true'
            >
              <template slot-scope="{ node, data }">
                <span style="display:block" @click="onClick(node)">{{ data.name }}</span>
                </template>
            </el-cascader>
            <!-- <md-tooltip md-direction="top">{{ tooltipValue }}</md-tooltip> -->
          </div>
              <!-- ************************************************** -->
              <!-- <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: 15px"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.one.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in typeList"
                      :key="index"
                      @click="chooseType(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu> -->
              <!-- ************************************************** -->

              <!-- ************************************************** -->
              <!-- <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: 15px"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.parentCode.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in listData2"
                      :key="index"
                      @click="chooseTypeTwo(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu> -->
              <!-- ************************************************** -->

              <!-- ************************************************** -->
              <!-- <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    style="margin-top: 15px"
                    class="md-button md-success dropdown-toggle deviceFilter"
                  >
                    {{ queryform.three.name }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(item, index) in listData3"
                      :key="index"
                      @click="chooseTypeThree(item)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="item.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu> -->
              <!-- ************************************************** -->

              <!-- <v-btn class="md-button md-success dropdown-toggle clearModel" @click="clearFilter">
                清除筛选
                <md-icon>filter_list_off</md-icon>
              </v-btn> -->
            </div>
          </div>
        </v-toolbar>

        <v-card-text class="px-0 py-0 textWrap">
          <v-progress-circular
            v-if="loading"
            indeterminate
            style="position: absolute; left: 0; right: 0; top: 18px; bottom: 0; margin: auto"
            color="rgb(76, 175, 80)"
          ></v-progress-circular>
          <v-data-table
            :headers="headers"
            :items="list"
            loading-text="加载中..."
            no-data-text="暂无数据"
            class="table"
            :page.sync="pagination.page"
            hide-default-footer
            :items-per-page="pagination.itemsPerPage"
            mobile-breakpoint="0"
            light
          >
            <!-- 表格头部搜索、新增 -->
            <template #top>
              <v-toolbar flat height="80">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="请输入名称"
                      single-line
                      hide-details
                      @keydown="keydownSearch"
                      class="valueFilter"
                    ></v-text-field>
           <md-tooltip md-direction="top">按回车以检索</md-tooltip>
                <!-- <v-spacer></v-spacer>
                <v-btn
                  height="35"
                  :ripple="false"
                  small
                  elevation="0"
                  class="font-weight-normal text-capitalize btn-primary bg-gradient-success py-3 px-6 ms-3"
                  >新增</v-btn
                > -->
              </v-toolbar>
            </template>
            <!-- <template #[`item.model_node_image`]="{ item }">
              <div class="img_wrapper d-inline-flex align-center">
                <img :src="item.model_node_image" style="cursor: pointer" />
              </div>
            </template> -->
            <template #[`item.label`]="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on">
                    {{ item.label }}
                  </a>
                </template>
                <span>
                  <img
                    :src="item.model_node_image"
                    style="display: block; width: 80px; height: 60px"
                    alt=""
                  />
                </span>
              </v-tooltip>
            </template>
            <template #[`item.updated_at`]="{ item }">
              <span>{{ dateFormat(item.updated_at) }}</span>
            </template>

            <template #[`item.status`]="{ item }">
              <span>{{ returnStatus(item) }}</span>
            </template>

            <template #[`item.model_priority`]="{ item }">
              <v-menu
                transition="slide-y-transition"
                offset-y
                nudge-bottom="5"
                :close-on-click="true"
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="md-button dropdown-toggle"
                    :style="{
                      background: setPriorityColor(item),
                    }"
                  >
                    {{ setPriorityName(item.model_priority) }}
                    <v-icon :class="['ni', value ? 'rotate-180' : '']"
                      >ni ni-bold-down text-xs ms-1</v-icon
                    >
                  </v-btn>
                </template>

                <v-list class="py-1" dense max-height="300">
                  <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                    <v-list-item
                      class="list-item-hover-active py-0 text-center"
                      v-for="(items, index) in model_priorityArr"
                      :key="items.code"
                      @click="changelPriority(item, items)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title
                          v-text="items.name"
                          class="text-body-2 ls-0 text-typo font-weight-600 mb-0 PriorityBtn"
                          :style="{ background: items.color }"
                        >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
              <!-- ************************************************** -->
            </template>

            <template #[`item.actions`]="{ item }" >
              <v-btn icon v-show="item.status == 9" @click="openAudit(item)" style="color: gray">
                {{ product(item) }}</v-btn
              >
              <!-- $store.getters.user.userId !== Number(item.creator) -->
              <v-btn
                icon
                v-show="item.status == 11"
                :disabled="getreceivingPresonId() !== item.receivingPreson"
                style="color: blue"
                @click="openAudit(item)"
              >
                {{ product(item) }}</v-btn
              >

              <v-btn
                icon
                :disabled="item.status == 12"
                v-show="item.status == 12"
                style="color: green !important"
                @click="openAudit(item)"
              >
                {{ product(item) }}</v-btn
              >

              <v-btn icon v-show="item.status == 14" style="color: red" @click="openAudit(item)">{{
                product(item)
              }}</v-btn>

              <v-btn style="margin-left: 20px; color: green !important" icon @click="review(item)">
                查看
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- 分页 -->
        <Pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :items-per-page.sync="pagination.itemsPerPage"
          @refresh="refreshResourceList"
        />

        <Process
          v-if="showProcessDialog"
          :showProcessDialog="showProcessDialog"
          :rowData="rowData"
          :textTitle="textTitle"
          @cancel="cancel"
        />
        <viewDialog
          :isView="isView"
          ref="view"
          @closeViewDialog="closeViewDialog"
          :viewDialogVisible="viewDialogVisible"
          v-if="viewDialogVisible"
          :viewDialogData="viewDialogData"
        ></viewDialog>

        <!-- :formData="auditNewData"
          :metaListData="queryParams[0].listData"
          @handleAgree="handleAgree"
          @handleReject="handleReject"
          @handleCancel="handleCancel" -->
      </v-card>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination/index';
import { headers } from './Setting/Header';
import viewDialog from '../../../DesignPage/Main/Action/modelResources/view.vue';
import Fuse from 'fuse.js';
import Swal from 'sweetalert2';
import moment from 'moment';
import DevNew from './Action/DevNew';
import Process from './Action/Process';
import { mapGetters } from 'vuex';
import {
  updateNewModelResource,
  list_model_resourceNew,
  queryModeDev,
  setModelPriority,
} from '@/api/model_resource';
import { categoryList } from '../../../../api/user';
export default {
  name: 'AuditMod',
  components: {
    DevNew,
    Pagination,
    Process,
    viewDialog,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      // 1最低  2.较低 3.普通 4.较高  5.最高
      optionsValue: ['all'],
      tooltipValue:'全部',
      cascaderProps: {
            label: 'name', 
            value: 'code',
            lazy: true,
            lazyLoad: (node, resolve) => {
            let that = this;
            const { level } = node;
            setTimeout(() => {
            if (node.level == 0) {
            let options = [
            {
              code: 'all',
              name: '全部',
              level: 0,
              leaf:true,
              children: [],
            },
            // { code: 'bjrs', name: '毕节人社', level: 0,  leaf:false, },
            { code: 'bk', name: '本科', level: 0 ,leaf:false },
            { code: 'gz', name: '高职', level: 0,leaf:false },
            { code: 'zz', name: '中职', level: 0,leaf:false },
            { code: 'gj', name: '技师学院', level: 0,leaf:false },
            { code: 'jx', name: '技校', level: 0,leaf:false },
            { code: 'qy', name: '企业', level: 0,leaf:false },
            ];

            resolve(options);
            }
            if (node.level == 1) {
            if (node.value == '') {
            return;
            }
            let params = {
            cate_type: node.value || '',
            level: '1',
            parentCode: '',
            };
            categoryList(params).then(res => {
            if (res.data) {
              res.data&&res.data.forEach(item=>{
                  item.leaf = false
              })
              if(params.cate_type!=='all'){
                  res.data.unshift({
                  cate_type: "all",
                  code: "all",
                  name: "全部",
                  _id: "123456",
                  children:[],
                  leaf:true,
                      level:1,
                  })
                }
                resolve(res.data);
            }
            })
            }
            if (node.level == 2) {

            let params = {
            cate_type: node.parent.value || '',
            level: '2',
            parentCode: node.value || '',
            };
            categoryList(params).then(res => {
            if (res.data) {
              res.data.forEach(item => {
                item.leaf = true;
              });
                if(params.parentCode!=='all'){
                    res.data.unshift({
                    cate_type: "all",
                    code: "all",
                    name: "全部",
                    _id: "111111111111111",
                    children:[],
                    leaf:true,
                    level:2,
                  })
              }

              resolve(res.data);
            }
            });
            } else if (node.level > 2) {
            resolve([]);
            }
            }, 100);
            },
      },
      model_priorityArr: [
        {
          name: '最低',
          code: 1,
          color: '#73d897',
        },
        {
          name: '较低',
          code: 2,
          color: '#5dcfff',
        },
        {
          name: '普通',
          code: 3,
          color: '#f6c659',
        },
        {
          name: '较高',
          code: 4,
          color: '#ff9f73',
        },
        {
          name: '最高',
          code: 5,
          color: '#FF7575',
        },
      ],
      productType: {},

      isView: '模型开发',
      viewDialogVisible: false,
      viewDialogData: {},
      textTitle: '',
      rowData: {},
      headers,
      // 搜索条件
      search: '',
      // 遮罩层
      loading: false,
      // 表格数据
      list: [],

      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 10,
        total: 0,
      },
      // 是否显示弹出框
      showProcessDialog: false,
      // 元件类型字典
      metaDict: {
        scene: '场景',
        role: '角色',
        tool: '工具',
        device: '设备',
      },
      // 状态
      statusListData: [],
      // 状态字典
      // statusDict: {},
      // 审核数据
      auditNewData: {},
      // 当前选中数据
      currentItem: {},

      //头部查询字段数据
      majorGroup: '',
      majorGroup2: '',
      listData1: [
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      listData2: [],
      listData3: [],
      type: 'bjrs',
      queryform: {
        priority: {
          name: '优先级',
          code: '1,2,3,4,5',
        },
        status: {
          name: '状态',
          code: '9,11,12,14',
        },
        one: {
          name: '适用',
          code: '',
        },
        level: '',
        parentCode: {
          name: '专业大类',
          code: '',
        },
        three: {
          name: '专业类',
          code: '',
        },
      },
      typeList: [
        { code: '', name: '  全部' },
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      //优先级
      priorityList: [
        { code: '1,2,3,4,5', name: '全部' },
        { code: 1, name: '最低' },
        { code: 2, name: '较低' },
        { code: 3, name: '普通' },
        { code: 4, name: '较高' },
        { code: 5, name: '最高' },
      ],
      //状态
      statusList: [
        { code: '9,11,12,14', name: '全部' },
        { code: 9, name: '待制作' },
        { code: 11, name: '制作中' },
        { code: 12, name: '制作完成' },
        { code: 14, name: '重新制作' },
      ],
      //头部查询字段数据
    };
  },

  created() {
    //更新状态字典
    // this.$dic.getStatusList(res => {
    //   this.statusListData = res;
    //   this.statusDict = res.reduce((pre, next) => {
    //     pre[next.index] = next.name;
    //     return pre;
    //   }, {});
    // });

    this.refreshResourceList();
    console.log(this.$store.getters.user);
  },
  mounted() {
    this.setFilter()
  
  },
  watch: {
    // 监听搜索
    queryParams: {
      handler: function (val, oldVal) {},
      immediate: true,
      deep: true,
    },
     optionsValue(val) {
      if (this.$refs.coursefilterWrap && val.length == 3) {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
      if (this.$refs.coursefilterWrap && val.length == 2 && val[1] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }

      if (this.$refs.coursefilterWrap && val.length == 1 && val[0] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    onClick(data){
      this.optionsValue = data.path;
      this.refreshResourceList()
      this.mouseenter(data)
      this.setFilter(data)
    },
 
    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
             this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
             this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
             this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }

    }, 

    mouseDown() {
      this.tooltipVisible = false;
    },
       setFilter(data){
      if(!data){
          let getNode = document.querySelector('.el-cascader .el-input__inner');
            getNode.style.width = 80+'px'
            return 
      }
        let getNode = document.querySelector('.el-cascader .el-input__inner');
       let str = ''
       if(data.pathLabels&&data.pathLabels.length>0){
            data.pathLabels.forEach(item=>{
                str+=item
            })
       }

        if(str.length<=5){
            getNode.style.width = ((str.length+3)*18)+'px'
            return 
        }
       if(str.length>17){
       getNode.style.width = ((str.length)*18)+'px'
       return 
       }
       getNode.style.width = ((str.length+2)*18)+'px'
    },
     onchange(data) {
        this.refreshResourceList();
    },
    //获取当前登录人的userId
    getreceivingPresonId() {
      let userId = null;
      if (window.localStorage.getItem('USER_INFO')) {
        userId = JSON.parse(window.localStorage.getItem('USER_INFO')).user.userId;
      }
      return userId;
    },
    setPriorityColor(item) {
      // 1.最低  2.较低 3.普通 4.较高  5.最高
      if (item.model_priority == 1) {
        return '#73d897  !important';
      } else if (item.model_priority == 2) {
        return '#5dcfff  !important';
      } else if (item.model_priority == 3) {
        return '#f6c659  !important';
      } else if (item.model_priority == 4) {
        return '#ff9f73  !important';
      } else if (item.model_priority == 5) {
        return '#FF7575  !important';
      }
    },
    setPriorityName(code) {
      // 1.最低  2.较低 3.普通 4.较高  5.最高
      if (code == 1) {
        return '最低';
      } else if (code == 2) {
        return '较低';
      } else if (code == 3) {
        return '普通';
      } else if (code == 4) {
        return '较高';
      } else if (code == 5) {
        return '最高';
      }
    },
    changelPriority(item, items) {
      if (!item._id || !items.code) return;
      let params = {
        _id: item._id,
        model_priority: items.code,
      };
      setModelPriority(params).then(res => {
        if (res.code == '200') {
          this.$notify({
            timeout: 1500,
            message: '优先级设置成功!',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.refreshResourceList();
        }
      });
    },
    resetquery() {
      this.queryform.parentCode = {
        name: '专业大类',
        code: '',
      };
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData2 = [];
      this.listData3 = [];
    },
    chooseType(item) {
      this.queryform.one = item;
      this.resetquery();
      this.pagination.page = 1;
      this.refreshResourceList();
      if (item.code == '') {
        return;
      }

      let params = {
        cate_type: this.queryform.one.code || '',
        level: '1',
        parentCode: '',
      };
      categoryList(params).then(res => {
        if (res.data) {
          this.listData2 = res.data;
        }
      });
    },
    priorityType(item) {
      this.queryform.priority = item;
      this.pagination.page = 1;
      this.refreshResourceList();
    },
    statusType(item) {
      this.queryform.status = item;
      this.pagination.page = 1;
      this.refreshResourceList();
    },
    chooseTypeTwo(item) {
      this.queryform.parentCode = item;
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData3 = [];
      this.pagination.page = 1;
      this.refreshResourceList();
      let params = {
        cate_type: this.queryform.one.code || '',
        level: '2',
        parentCode: this.queryform.parentCode.code,
      };

      categoryList(params).then(res => {
        if (res.data) {
          this.listData3 = res.data;
        }
      });
    },
    chooseTypeThree(item) {
      this.queryform.three = item;
      this.pagination.page = 1;
      this.refreshResourceList();
    },
    closeViewDialog() {
      this.viewDialogVisible = false;
    },
    review(item) {
      this.viewDialogData = item;
      this.viewDialogVisible = true;
    },
    product(item) {
      if (item.status == 9) {
        return '接取';
      } else if (item.status == 11) {
        return '上传模型';
      } else if (item.status == 12) {
        return '制作完成';
      } else if (item.status == 14) {
        return '重新接取';
      }
    },
    returnStatus(item) {
      if (item.status == 9) {
        return '待制作';
      } else if (item.status == 11) {
        return '制作中';
      } else if (item.status == 12) {
        return '制作完成';
      } else if (item.status == 14) {
        return '重新制作';
      }
    },

    /**
     * 审核按钮
     */
    openAudit(item) {
      this.showProcessDialog = true;
      this.rowData = item;
      if (item.status == 9) {
        this.textTitle = '是否进行作品制作？';
      } else if (item.status == 11) {
        this.textTitle = '是否提交制作模型？';
      } else if (item.status == 14) {
        this.textTitle = '是否重新制作模型？';
      }
    },
    /**
     * 时间格式化
     */
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 清除筛选
     */
    clearFilter() {
      this.search = '';
      this.queryParams.forEach(item => {
        item.value = 0;
        item.code = '';
      });
      this.refreshResourceList();
    },
    /**
     * 查询列表
     */
    refreshResourceList() {
      const tempData1 = {
        label: this.search,
        refer: this.optionsValue[0]==''?'all':this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1]=='all'?'':this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2]=='all'?'':this.optionsValue[2] || '',
        // status: '9,11,12,14',
        currentPage: this.pagination.page,
        perPage: this.pagination.itemsPerPage,
        model_priority: this.queryform.priority.code.toString() || '',
        status: this.queryform.status.code.toString() || '',
      };

      this.loading = true;
      list_model_resourceNew(tempData1).then(res => {
        this.list = res.data.items;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },
    /**
     * 通过/驳回事件处理
     */
    handleAction(e) {
      this.showNewDialog = false;
      this.currentItem.apply_list.push({
        status: this.currentItem.status,
        remark: e.option,
        operator: this.currentItem.updater,
      });

      updateNewModelResource(this.currentItem).then(res => {
        if (res.code === '200') {
          this.$refs.view.btnLoading = false;
          this.$notify({
            timeout: 1500,
            message: '操作成功！',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.refreshResourceList();
        } else {
          this.$notify({
            timeout: 1500,
            message: '操作失败',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'warning',
          });
        }
      });
    },

    /**
     * 通过
     */
    handleAgree(e) {
      if (this.currentItem.status === 5) this.currentItem.status = 7;
      else if (this.currentItem.status === 1) this.currentItem.status = 3;
      this.handleAction(e);
    },
    /**
     * 驳回
     */
    handleReject(e) {
      if (this.currentItem.status === 5) this.currentItem.status = 6;
      else if (this.currentItem.status === 1) this.currentItem.status = 2;
      this.handleAction(e);
    },
    /**
     * 关闭弹出框
     */
    cancel() {
      this.showProcessDialog = false;
      this.refreshResourceList();
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.page = 1;
        this.refreshResourceList();
      }
    },
  },
};
</script>
<style  scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.header_wrapper {
  width: 100%;
  padding: 15px;
}

.model_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  border-radius: 7px;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
}

.img_wrapper {
  width: 64px;
  height: 64px;
}

.img_wrapper img {
  width: 100%;
  height: 100%;
}
.v-List-actived {
  background: #ddd;
}
.disable-color {
  color: #ddd !important;

}

  .disable-color i {
    color: #ddd !important;
  }

.textWrap {
  position: relative;
}

.PriorityBtn {
  padding: 5px;
  border-radius: 12px;
  color: #fff !important;
}

.table {
  min-height: 610px;
}



#coursefilterWrap {
  margin-top: 18px;
  margin-left: 10px;
  /* width: 320px; */
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}
.MobileToolbar{
  display: none;
}
@media (max-width:600px) {
   .MobileToolbar{
     display: block;
     background: #4caf50 !important;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
   }
   .pcToolbar{
    display: none;
   }
  
}
</style>
